import { Component, Input, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';
import { State, getAssessmentTest, getTestNavigation } from './../../../../../../store/reducers';

import { InteractionTypeEnum } from './../../../../../../dtos/enums';
import { TestContentService } from '../../../../../../services/test-content.service';
import { TestNavigationService } from '../../../../../../services/test-navigation.service';
import { PreviewService } from '../../../../../../services/preview.service';
import { AnswerKeyService } from '../../../../../../services/answerkey.service';
import { ResponseService } from '../../../../../../services/response.service';

interface TestletAnswerKey {
    TestletId: number;
    TestletTitle: string;
    InteractionAnswers: InteractionAnswer[];
}

interface InteractionAnswer {
    ItemIndex: number;
    InteractionType: string;
    CorrectResponses: string;
    UserResponses: string;
    IsCorrect: boolean;
}

@Component({
    selector: 'ipp-answerkey',
    template: require('./ipp-answerkey.component.html'),
    changeDetection: ChangeDetectionStrategy.Default
})
export class IppAnswerkeyComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() title: string;
    @Input() resourceId: number;

    testlets = [];
    answerKeys : TestletAnswerKey[] = [];
    answerKeyReady: boolean = false;
    isFOST: boolean = true;

    private assessmentTestSubscription: Subscription;
    private assessmentTest: PgRendererDto.AssessmentTest;
    private testNavigationSubscription: Subscription;
    private testNavigation: PgRendererDto.TestNavigation;

    constructor(
        private store: Store<State>,
        private responseService: ResponseService,
        private answerKeyService: AnswerKeyService,
        private previewService: PreviewService,
        private testNavigationService: TestNavigationService,
        private testContentService: TestContentService
    ) {
        this.testNavigationSubscription = store.select(getTestNavigation).subscribe(testNavigation => {
            this.testNavigation = testNavigation;
            this.answerKeys = [];
            this.answerKeyUpdate(this.testNavigation, this.assessmentTest);
        });

        this.assessmentTestSubscription = store.select(getAssessmentTest).subscribe(assessmentTest => {
            this.assessmentTest = assessmentTest;
            this.answerKeys = [];
            this.answerKeyUpdate(this.testNavigation, this.assessmentTest);
        });
    }

    
    ngOnInit() {
        this.testContentService.getProductInfo(this.assessmentTest.Identifier).subscribe(productDto => {
            this.isFOST = !productDto.NeedsPurchase;
        });
    }

    ngAfterViewInit() {
        
    }

    ngOnDestroy() {
        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
        if (this.assessmentTestSubscription) {
            this.assessmentTestSubscription.unsubscribe();
        }
    }

    private getInteractionResponses = (answerKeyDtos: PgRendererDto.AnswerkeyDto[]): PgRendererDto.InteractionResponse[] => {
        const interactionIds = [].concat.apply([], answerKeyDtos.map(a => a.InteractionDefinitions.map(i => i.InteractionId)));
        return this.responseService.responses.filter(x => interactionIds.indexOf(x.InteractionId) >= 0);
    }

    answerKeyUpdate(testNavigation: PgRendererDto.TestNavigation, assessmentTest: PgRendererDto.AssessmentTest) {
        if (testNavigation && assessmentTest) {
            this.answerKeyReady = false;

            let testPartIndex = testNavigation.testPartIndex;
            this.testlets = this.testNavigationService.getTestletsByTestPart(assessmentTest.TestParts[testPartIndex], testPartIndex);

            let answerKeyDtos: PgRendererDto.AnswerkeyDto[] = [];
            let interactionResponses: PgRendererDto.InteractionResponse[] = [];
            let testletIds = this.testlets.map(t => t.testletId);
            this.answerKeyService
                .getAnswerKeys(testletIds)
                .map(dtos => { 
                    answerKeyDtos = dtos;
                    interactionResponses = this.getInteractionResponses(dtos);
                    return interactionResponses;
                })
                .flatMap(interactionResponses => this.testContentService.getPreviewResponseScores(interactionResponses))
                .subscribe(responseScoreDto => {
                    for (var i = 0; i < this.testlets.length; i++) {
                        const testlet = this.testlets[i];
                        let testletAnswerKey : TestletAnswerKey = {
                            TestletId: testlet.testletId,
                            TestletTitle: testlet.title,
                            InteractionAnswers: []
                        }
                        const answerKey = answerKeyDtos.find(a => a.TestletId == testlet.testletId);
                        for (var j = 0; j < answerKey.InteractionDefinitions.length; j++) {
                            let interaction = answerKey.InteractionDefinitions[j];
                            let interactionAnswer : InteractionAnswer = {
                                ItemIndex: interaction.ItemIndex,
                                InteractionType: interaction.InteractionTypeName,
                                CorrectResponses: this.previewService.createCorrectAnswerHtml(interaction),
                                UserResponses: this.previewService.createUserResponseHtml(interaction, interactionResponses.find(r => r.InteractionId == interaction.InteractionId)),
                                IsCorrect: this.isCorrect(interaction, responseScoreDto.ResponseScores.find(r => r.InteractionId == interaction.InteractionId))
                            };
                            testletAnswerKey.InteractionAnswers.push(interactionAnswer);
                        }
                        if (testletAnswerKey.InteractionAnswers.length > 0) {
                            this.answerKeys.push(testletAnswerKey); 
                        }
                    }
                    this.answerKeyReady = true;  
                });
        }
    }
    
    private isCorrect(interaction: PgRendererDto.InteractionDefinition, responseScore: PgRendererDto.ResponseScore) {
        switch (interaction.InteractionTypeId as any) {
            case InteractionTypeEnum.Choice:
            case InteractionTypeEnum.InlineChoice:
            case InteractionTypeEnum.TextEntry:
            case InteractionTypeEnum.Order:
            case InteractionTypeEnum.Associate:
            case InteractionTypeEnum.Match:
            case InteractionTypeEnum.Hotspot:
                return responseScore != null && responseScore.Score > 0;
            case InteractionTypeEnum.ExtendedText:
            case InteractionTypeEnum.Speaking:            
                return null;
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-answerkey/ipp-answerkey.component.ts